import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class NavOverriderService {

  private _backfunction: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor() {
  }

  setCustomCloseFunction(backHandler) {
    this._backfunction.next(backHandler)
  }
  
  getCustomCloseFunction() {
    return this._backfunction;
  }
}
